/**
 * @generated SignedSource<<f3a46c3bf814c16ad3dca9243bed529f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MusicParseStatus = "ERROR" | "IN_PROGRESS" | "NOT_STARTED" | "SKIPPED" | "SUCCESS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type StaffSelectWorkspace_piece$data = {
  readonly id: string;
  readonly sheets: ReadonlyArray<{
    readonly id: string;
    readonly bar_finder_steps: ReadonlyArray<{
      readonly id: string;
      readonly status: MusicParseStatus;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"StaffSelectPage_sheet">;
  }>;
  readonly " $fragmentType": "StaffSelectWorkspace_piece";
};
export type StaffSelectWorkspace_piece$key = {
  readonly " $data"?: StaffSelectWorkspace_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"StaffSelectWorkspace_piece">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StaffSelectWorkspace_piece",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicSheet",
      "kind": "LinkedField",
      "name": "sheets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StaffSelectPage_sheet"
        },
        {
          "alias": "bar_finder_steps",
          "args": [
            {
              "kind": "Literal",
              "name": "step_type",
              "value": "BAR_FINDER"
            }
          ],
          "concreteType": "MusicParseStep",
          "kind": "LinkedField",
          "name": "steps",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": "steps(step_type:\"BAR_FINDER\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};
})();

(node as any).hash = "d9daf11c04be289e14ba8f20338a95c9";

export default node;
